import { ApiLinkEntity, ApiLinkRel } from "config/constants";
import { IApiLink } from "@/types";
import WorkingDaysCalendar, { IGetWorkingDaysCalendarDto } from "./WorkingDaysCalendar";

export interface IGetWorkingDaysCalendarsDto {
    entities: IGetWorkingDaysCalendarDto[]
    links: IApiLink[]
}

export default class WorkingDaysCalendars {
    items: WorkingDaysCalendar[]
    linkCreate?: IApiLink

    constructor(dto: IGetWorkingDaysCalendarsDto) {
        this.items = dto.entities.map(entityDto => new WorkingDaysCalendar(entityDto))
        this.linkCreate = dto.links.find(link => link.entity === ApiLinkEntity.workingDaysCalendar && link.rel === ApiLinkRel.new)
    }
}
